/**
 * Переключатели возможностей, которые временно не используются.
 *
 * Код таких разделов остаётся в проекте целиком — выключен только вход в них.
 * Это честнее закомментированных кусков: видно, что именно скрыто, почему,
 * и включается обратно одной строкой без поиска по файлам.
 */

/**
 * Генерация тестов через AI (DeepSeek).
 *
 * Выключено по решению заказчика: возможностью не пользуются. Страница
 * src/pages/AITestGenerator.tsx, её маршрут и серверные эндпоинты остаются
 * на месте; скрыты только кнопка в админ-панели, режим «С помощью AI»
 * в мастере создания теста и переход на страницу.
 *
 * Чтобы вернуть — поставить true.
 */
export const AI_TEST_GENERATION_ENABLED = false;

/**
 * Рабочее место «Тесты» (список, мастер создания теста, готовые вопросы, выдача).
 *
 * Включено по умолчанию, чтобы сборка из копии исходников без .env не скрывала раздел.
 * Для временного отключения задайте REACT_APP_TESTS_WORKSPACE=false при запуске или сборке.
 * Тогда /admin/tests остаётся переходом на доску назначений, а пункта меню нет.
 */
export const TESTS_WORKSPACE_ENABLED = (process.env.REACT_APP_TESTS_WORKSPACE ?? 'true') === 'true';
